import { HONEYPOT_FIELD_NAMES } from '@/config/security';

export function getClientMetadata() {
  const honeypotFields = {};
  HONEYPOT_FIELD_NAMES.forEach(fieldName => {
    honeypotFields[fieldName] = '';
  });

  return {
    ...honeypotFields,

    client_timestamp: Date.now() / 1000,

    screen_resolution: `${window.screen.width}x${window.screen.height}`,

    timezone: -new Date().getTimezoneOffset() / 60,

    platform: navigator.platform || 'unknown',
    language: navigator.language || 'unknown',
    color_depth: window.screen.colorDepth || 'unknown'
  };
}


export function validateHoneypots(metadata) {
  if (!metadata) return false;

  for (const field of HONEYPOT_FIELD_NAMES) {
    if (metadata[field] && String(metadata[field]).trim()) {
      console.warn('[ClientMetadata] Honeypot field filled:', field);
      return false;
    }
  }

  return true;
}
